import React, { useState, useEffect } from "react";
import UserHeader from "./UserHeader";
import { ToastContainer, toast } from "react-toastify";
import {
  getUserSurveyAnalysisPreview,
  deleteUserAnalysisGraph,
} from "../../Utils/userFunctions";
import { useParams, Link } from "react-router-dom";
import { get_Date, getSurveyStatusName } from "../../Utils/commonFunctions";
import {
  QuestionOption,
  AnalysisGraph,
  TextResponces,
} from "./commonComponent";
import { Bar } from "react-chartjs-2";
import UserAnalysisPreviewDownload from "./UserAnalysisPreviewDownload";

function UserAnalysisPreview() {
  const [surveyData, setSurveyData] = useState("");
  const [surveyStatus, setSurveyStatus] = useState("");
  const [chartQuestion, setChartQuestion] = useState("");
  const [questionType, setQuestionType] = useState("");
  const [isChart, setIsChart] = useState(0);
  const [colors, setColors] = useState([]);
  const [reportsChartsData, setReportsChartsData] = useState("");
  const [options, setOptions] = useState("");
  const [textResponse, setTextResponse] = useState("");
  const [tmpDeleteID, setTmpDeleteID] = useState("");
  const [title, setTitle] = useState("");
  const [tmpPopupchartData, setTmpPopupchartData] = useState([]);
  const { surveyID, questionID, questionNo } = useParams();
  const labels = [""];
  const optionsChart = {
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: title,
        padding: {
          top: 10,
          bottom: 10,
        },
        color: "#0069d9",
      },
      scales: {
        xaxis: {
          beginAtZero: true,
          ticks: {
            stepSize: 1.0,
          },
        },
      },
    },
  };
  useEffect(() => {
    UserSurveyAnalysisPreview();
  }, []);
  const UserSurveyAnalysisPreview = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append("survey_id", surveyID);
    bodyFormData.append("question_id", questionID);
    bodyFormData.append("question_no", questionNo);
    const response = await getUserSurveyAnalysisPreview(bodyFormData);

    if (response.status == "success") {
      setSurveyData(response.data[0]);
      setColors(response.data[0].COLOR);
      if (Object.keys(response.data[0].reportscharts).length === 0) {
        setIsChart(0);
        setReportsChartsData("");
      } else {
        setIsChart(1);
        let tempChartData = response.data[0].reportscharts.map((item, i) => {
          return (
            <AnalysisGraph
              reportsCharts={item}
              key={i}
              handleDelete={handleDelete}
              handlePopup={handlePopup}
            />
          );
        });

        setReportsChartsData(tempChartData);
      }

      if (response.data[0].chartquestion.options === "") {
        setOptions("");
      } else {
        setOptions(response.data[0].chartquestion.options);
      }
      if (Object.keys(response.data[0].textresponse).length === 0) {
        setTextResponse("");
      } else {
        let tempTextResponcesData1 = response.data[0].textresponse.map(
          (item, i) => {
            return (
              <>
                <TextResponces
                  label={item.label}
                  key={i}
                  key1={i}
                  textResponseItem={item.textresponseitem}
                />
              </>
            );
          }
        );

        setTextResponse(tempTextResponcesData1);
      }
      setChartQuestion(response.data[0].chartquestion);
      setSurveyStatus(response.data[0].status);
      setQuestionType(response.data[0].chartquestion.type);
    } else {
      toast.error(response.message, { autoClose: 1500 });
    }
  };
  let handlePopup = (title, graphData) => {
    setTitle(title);
    setTmpPopupchartData(graphData);
  };

  const handleDelete = (analysisID) => {
    setTmpDeleteID(analysisID);
  };

  const handleUserAnalysisDelete = async () => {
    const response = await deleteUserAnalysisGraph(surveyID, tmpDeleteID);
    if (response.status === "success") {
      toast.success(response.message, { autoClose: 1500 });
      document.getElementById("modal-default").click();
      UserSurveyAnalysisPreview();
    } else {
      toast.error(response.message, { autoClose: 1500 });
    }
  };
  return (
    <div>
      <UserHeader />
      <ToastContainer></ToastContainer>
      <div className="modal fade show" id="modal-chart" arial-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <Bar
                options={optionsChart}
                data={{
                  labels,
                  datasets: tmpPopupchartData,
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade show" id="modal-default" arial-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Confirm delete</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete this record?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-sm btn-dark"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={() => handleUserAnalysisDelete()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row mt-4">
          <div className="col-md-4">
            <div className="card vd-card">
              <div className="card-body">
                <div className="pmcf-content-info">
                  <span className="custom_survey_name">
                    {surveyData.survey_name}
                  </span>
                  <hr
                    style={{
                      border: "1px solid #006CB5",
                      borderRadius: 10,
                    }}
                  />

                  <div className="pmcf-survey-list" style={{ marginTop: "5%" }}>
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">Status</div>
                      <div className="pmcf-survey-value">
                        {getSurveyStatusName(surveyStatus)}
                      </div>
                    </div>
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">Launch Date</div>
                      <div className="pmcf-survey-value">
                        {surveyData.launch_date
                          ? get_Date(surveyData.launch_date)
                          : "Survey is yet to be launched"}
                      </div>
                    </div>
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">Completion Date</div>
                      <div className="pmcf-survey-value">
                        {get_Date(surveyData.completion_date)}
                      </div>
                    </div>
                  </div>
                  <div className="pmcf-survey-question-point">
                    <h2 style={{ color: "#006CB5" }}>
                      {" "}
                      {surveyData.no_of_question}
                    </h2>
                    <p style={{ color: "black" }}>QUESTIONS</p>
                  </div>
                  <div className="pmcf-survey-list">
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">
                        Number of Participants
                      </div>
                      <div className="pmcf-survey-value">
                        {" "}
                        {surveyData.no_of_paticipants}
                      </div>
                    </div>
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">Responses</div>
                      <div className="pmcf-survey-value">
                        {surveyData.no_of_responses} /{" "}
                        {surveyData.no_of_paticipants}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <div className="card vd-card response-list scrollbar-custom square thin">
              <p className="text-right m-2">
                <h3 className="card-title">
                  <UserAnalysisPreviewDownload />
                </h3>

                <h3 className="card-title pull-right ">
                  <Link
                    to={"/manufacturer-create-analysis/" + surveyID}
                    className="btn btn-sm custom-btn-primary pull-right"
                  >
                    <i className="fa fa-arrow-left"></i> Back
                  </Link>
                </h3>
              </p>

              <div className="card-body">
                <div className="pmcf-content-info1">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="sar-question p-1">
                            <div className="sar-question-number">
                              {surveyData.question_no}
                            </div>
                            <span className="sar-question-text">
                              {chartQuestion.label}
                              {chartQuestion.type === "survey"
                                ? " > " + chartQuestion.survey_label
                                : ""}
                            </span>
                          </div>
                          {(chartQuestion.type === "radio" ||
                            chartQuestion.type === "selectboxes" ||
                            chartQuestion.type === "survey") && (
                            <QuestionOption
                              questionType={questionType}
                              isChart={isChart}
                              options={options}
                              colors={colors}
                            />
                          )}
                          {reportsChartsData != "" && reportsChartsData}
                          {textResponse && (
                            <div className="row">
                              <div className="col-md-12 text-left">
                                <h6 className="p-0">
                                  <strong>Text response</strong>
                                </h6>
                              </div>
                              {textResponse}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserAnalysisPreview;
